import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Products
export const getProducts = async () => {
  const response = await axios.get(`${API}/products`);
  return Array.isArray(response?.data) ? response.data : [];
};

export const getProduct = async (slug) => {
  const response = await axios.get(`${API}/products/${slug}`);
  return response.data;
};

// Blog
export const getBlogArticles = async (publishedOnly = true) => {
  const response = await axios.get(`${API}/blog`, {
    params: { published_only: publishedOnly }
  });
  return Array.isArray(response?.data) ? response.data : [];
};

export const getBlogArticle = async (slug) => {
  const response = await axios.get(`${API}/blog/${slug}`);
  return response.data;
};

export const createBlogArticle = async (article) => {
  const response = await axios.post(`${API}/blog`, article);
  return response.data;
};

export const updateBlogArticle = async (articleId, update) => {
  const response = await axios.put(`${API}/blog/${articleId}`, update);
  return response.data;
};

export const deleteBlogArticle = async (articleId) => {
  const response = await axios.delete(`${API}/blog/${articleId}`);
  return response.data;
};

// Reviews
export const getReviews = async (productId = null) => {
  const params = productId ? { product_id: productId } : {};
  const response = await axios.get(`${API}/reviews`, { params });
  return Array.isArray(response?.data) ? response.data : [];
};

export const createReview = async (review) => {
  const response = await axios.post(`${API}/reviews`, review);
  return response.data;
};

// Checkout
export const createCheckout = async (checkoutData) => {
  const originUrl = window.location.origin;
  const response = await axios.post(`${API}/checkout`, {
    ...checkoutData,
    origin_url: originUrl
  });
  return response.data;
};

export const getCheckoutStatus = async (sessionId) => {
  const response = await axios.get(`${API}/checkout/status/${sessionId}`);
  return response.data;
};

export const getOrder = async (orderId) => {
  const response = await axios.get(`${API}/orders/${orderId}`);
  return response.data;
};

// Seed database
export const seedDatabase = async () => {
  try {
    const response = await axios.post(`${API}/seed`);
    return response.data;
  } catch (error) {
    console.log("Database may already be seeded");
  }
};
